/** Native Polaris presentation only; request owners decide whether a failure remains true. */
export function RequestFailureBanner({
  message,
  pending = false,
  disabled = false,
  onRetry,
  actionLabel = 'Try again',
}: {
  message: string
  pending?: boolean
  disabled?: boolean
  onRetry?: () => void | Promise<unknown>
  /** What the recovery button says. The caller chooses it from the failure kind (retry, or load the saved version). */
  actionLabel?: string
}) {
  const retryAction = onRetry ? (
    <s-button
      slot="secondary-actions"
      disabled={pending || disabled}
      onClick={() => {
        void onRetry()
      }}
    >
      {actionLabel}
    </s-button>
  ) : null
  return (
    <s-banner tone="critical">
      <s-text>{message}</s-text>
      {retryAction}
    </s-banner>
  )
}
